<template>
    <navbar position="fixed" :transparent="transparent" :color-on-scroll="colorOnScroll"  menu-classes="ml-auto">
        <template slot-scope="{toggle, isToggled}">
                <router-link class="navbar-brand" to="/">
                    <img src="/img/logo.svg" width="70px" height="70px" alt="MINOREC">
                </router-link>
        </template>

        <template slot="navbar-menu">
            <li class="nav-item">
                <router-link class="router-link-item nav-link" to="/spolecnost"> O společnosti </router-link>
            </li>            
            <li class="nav-item">
                <router-link class="router-link-item nav-link" to="/sluzby"> Služby </router-link>
            </li>            
            <li class="nav-item">
                <router-link class="router-link-item nav-link" to="/iso"> ISO </router-link>
            </li>            
            <li class="nav-item">
                <router-link class="router-link-item nav-link" to="/odpady"> Odpady </router-link>
            </li>            
            <li class="nav-item">
                <router-link class="router-link-item nav-link" to="/kontakty"> Kontakty </router-link>
            </li>            
            <li class="nav-item">
                <router-link class="router-link-item nav-link" to="/stahnout"> Ke stažení </router-link>
            </li>
            <li class="nav-item">
                <router-link class="router-link-item nav-link" to="/objednat"> Objednávka </router-link>
            </li>
        </template>
    </navbar>
</template>

<script>
  import { DropDown, NavbarToggleButton, Navbar, NavLink } from '@/components';
  import { Popover } from 'element-ui'
  export default {
    name: 'main-navbar',
    props: {
      transparent: Boolean,
      colorOnScroll: Number,
    },
    components: {
      DropDown,
      Navbar,
      NavbarToggleButton,
      NavLink,
      [Popover.name]: Popover
    }
  }
</script>

<style scoped>
.router-link-item {
    text-transform: uppercase;
    font-size: 0.9em !important;
    font-weight: 800 !important;
    padding: 0.5rem 0.7rem;
    line-height: 1.625rem;
    display: block;
    box-sizing: border-box;
    vertical-align: middle;
    transition: all 300ms ease 0s;
    text-decoration: none;
    background-color: transparent;
}

.router-link-item:hover {
    text-transform: uppercase;
    font-size: 0.7142em;
    padding: 0.5rem 0.7rem;
    line-height: 1.625rem;
    display: block;
    box-sizing: border-box;
    vertical-align: middle;
    transition: all 300ms ease 0s;
    text-decoration: none;
    background-color: rgba(255, 255, 255, 0.2);
    border-radius: 0.1875rem;
}

.navbar.bg-white:not(.navbar-transparent)  {
    background-color: rgba(222, 222, 222, 0.3);
}

.navbar, .navbar-brand {
    padding: 0rem, 0rem !important;
    padding-top: 0.2rem !important;
    padding-bottom: 0.2rem !important;
}

</style>

